export default "__VITE_ASSET__b43vmkHc__"